import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "fw-bold fs-5 text-uppercase text-truncate"
};
const _hoisted_4 = { class: "sidebar-menu mt-2" };
const _hoisted_5 = {
    class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
    id: "sidebarNavAccordion"
};
const _hoisted_6 = {
    key: 0,
    class: "sub-title sidebar-nav-item"
};
const _hoisted_7 = { class: "d-block text-uppercase fw-medium" };
const _hoisted_8 = {
    key: 1,
    class: "sidebar-nav-item"
};
const _hoisted_9 = { class: "title" };
const _hoisted_10 = {
    key: 2,
    class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
};
const _hoisted_11 = ["data-bs-target", "aria-controls"];
const _hoisted_12 = { class: "title" };
const _hoisted_13 = ["id"];
const _hoisted_14 = { class: "accordion-body" };
const _hoisted_15 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
            'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
            { active: _ctx.stateStoreInstance.open },
        ]),
        id: "sidebar-area"
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
                to: _ctx.UserGeneralKey.getDashboardRoute(_ctx.userRole),
                class: "d-flex align-items-center text-white text-decoration-none px-3"
            }, {
                default: _withCtx(() => [
                    (_ctx.franchiseLogo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.franchiseLogo,
                            class: "sidebar-logo-img",
                            alt: "logo-icon"
                        }, null, 8, _hoisted_2))
                        : (_ctx.franchiseName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.franchiseName), 1))
                            : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["to"]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
            _createElementVNode("button", {
                class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
            }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
                ]))])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMenu, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.id || index
                    }, [
                        (item.subTitle)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(item.subTitle.startsWith('sidebar.') ? _ctx.$t(item.subTitle) : item.subTitle), 1)
                            ]))
                            : (!item.children)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                                    _createVNode(_component_router_link, {
                                        to: _ctx.getRoute(item),
                                        class: _normalizeClass(["sidebar-nav-link d-block", item.class]),
                                        onClick: ($event) => (_ctx.handleItemClick(item))
                                    }, {
                                        default: _withCtx(() => [
                                            (item.icon)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(item.icon)
                                                }, null, 2))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.title && item.title.startsWith('sidebar.') ? _ctx.$t(item.title) : item.title), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["to", "class", "onClick"])
                                ]))
                                : (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                    _createElementVNode("a", {
                                        href: "#",
                                        class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": '#collapse-' + item.id,
                                        "aria-expanded": "false",
                                        "aria-controls": 'collapse-' + item.id
                                    }, [
                                        (item.icon)
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: _normalizeClass(item.icon)
                                            }, null, 2))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(item.title && item.title.startsWith('sidebar.') ? _ctx.$t(item.title) : item.title), 1)
                                    ], 8, _hoisted_11),
                                    _createElementVNode("div", {
                                        id: 'collapse-' + item.id,
                                        class: "accordion-collapse collapse",
                                        "data-bs-parent": "#sidebarNavAccordion"
                                    }, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("ul", _hoisted_15, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: child.id,
                                                        class: "sidebar-sub-menu-item"
                                                    }, [
                                                        _createVNode(_component_router_link, {
                                                            to: _ctx.getRoute(child),
                                                            class: _normalizeClass(["sidebar-sub-menu-link", child.class]),
                                                            onClick: _ctx.stateStoreInstance.onChange
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(child.title && child.title.startsWith('sidebar.') ? _ctx.$t(child.title) : child.title), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to", "class", "onClick"])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ], 8, _hoisted_13)
                                ]))
                    ], 64));
                }), 128))
            ])
        ])
    ], 2));
}
